export const LOCAL_TRANSFER_STATES = Object.freeze({
  IDLE: "idle",
  CREATING_OFFER: "creatingOffer",
  SHOWING_OFFER_QR: "showingOfferQr",
  SCANNING_OFFER: "scanningOffer",
  SHOWING_ANSWER_QR: "showingAnswerQr",
  SCANNING_ANSWER: "scanningAnswer",
  CONNECTING: "connecting",
  CONFIRMING_CODE: "confirmingCode",
  CONNECTED: "connected",
  TRANSFERRING: "transferring",
  RECEIVED: "received",
  FAILED: "failed",
});

export const LOCAL_TRANSFER_ROLES = Object.freeze({
  SENDER: "sender",
  RECEIVER: "receiver",
});

export const SIGNAL_TYPES = Object.freeze({
  OFFER: "offer",
  ANSWER: "answer",
});

export const TRANSFER_MESSAGE_TYPES = Object.freeze({
  NOTE_METADATA: "note-metadata",
  FILE_CHUNK: "file-chunk",
  RECEIVER_READY: "receiver-ready",
  TRANSFER_COMPLETE: "transfer-complete",
  TRANSFER_ERROR: "transfer-error",
});

export const SIGNAL_FRAME_KIND = "netpad-local-signal";
export const SIGNAL_FRAME_VERSION = 1;
export const SIGNAL_FRAME_MAX_LENGTH = 900;
export const FILE_CHUNK_BYTES = 16 * 1024;
export const DATA_CHANNEL_LABEL = "netpad-local-transfer";
export const BUFFERED_AMOUNT_LOW_BYTES = 256 * 1024;
export const BUFFERED_AMOUNT_LIMIT_BYTES = 1024 * 1024;
export const QR_FRAME_ROTATION_MS = 1400;
export const QR_SCAN_RETRY_MS = 250;
export const LOCAL_TRANSFER_ERROR_MESSAGE =
  "Local transfer failed. Check camera permission, same Wi-Fi, router client isolation, QR expiry, or browser support.";
